/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Scope_Detail5Inputs */

const en_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define exactly what the agent should (and shouldn't) do autonomously.`)
};

const ar_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد بدقة ما يجب على الوكيل فعله (وما لا يجب) بشكل مستقل.`)
};

const bn_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এজেন্ট কী কী (এবং কী কী নয়) অটোনোমাসলি করবে তা নির্ধারণ করুন।`)
};

const de_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definieren Sie genau, was der Agent autonom tun soll (und was nicht).`)
};

const es_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir exactamente lo que el agente debe (y no debe) hacer de forma autónoma.`)
};

const fr_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définissez exactement ce que l'agent doit (et ne doit pas) faire de manière autonome.`)
};

const pt_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina exatamente o que o agente deve (e não deve) fazer de forma autônoma.`)
};

const zh_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准确定义代理应该（和不应该）自主做什么。`)
};

const tr_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajanınızın özerk olarak ne yapması gerektiğini (ve yapmaması gerektiğini) tam olarak tanımlayın.`)
};

const ru_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точно определите, что агент должен (и не должен) делать автономно.`)
};

const pl_svc_ai_agent_development_scope_detail5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdefiniuj dokładnie, co agent powinien (a czego nie powinien) robić autonomicznie.`)
};

/**
* | output |
* | --- |
* | "Define exactly what the agent should (and shouldn't) do autonomously." |
*
* @param {Svc_Ai_Agent_Development_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_scope_detail5 = /** @type {((inputs?: Svc_Ai_Agent_Development_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "de") return de_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "es") return es_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_scope_detail5(inputs)
	return en_svc_ai_agent_development_scope_detail5(inputs)
});
export { svc_ai_agent_development_scope_detail5 as "svc_ai-agent-development_SCOPE_detail" }